import styled from "styled-components";

type ButtonStyleTypes = {
  className?: string;
  primary?: boolean;
};

const defaultClassName = `cursor-pointer border p-4 rounded-lg w-full`;

const Button = styled.button.attrs<ButtonStyleTypes>((props) => ({
  className: `${defaultClassName} ${props.className}`,
}))<ButtonStyleTypes>``;

export default {
  Button,
};
